export default __webpack_public_path__ + "static/media/Olim5.da5c9d4d.png";